<form [formGroup]="savedFiltersForm">
  <div class="saved-filters-container">
    <button class="saved-filter-button" (click)="toggleMenu($event)" [ngClass]="{'showing': isSavedFiltersMenuShowing}">
      <span class="icon-primary" [ngClass]="{'icon-white': isSavedFiltersMenuShowing}">Saved Filters</span>
      <svg-icon-sprite class="chevron-down icon-primary" [ngClass]="{'icon-white': isSavedFiltersMenuShowing}" [src]="'assets/sprites/sprite.svg#icon-chevron-down'" [viewBox]="'0 0 32 32'" [width]="'16px'" [height]="'16px'"></svg-icon-sprite>
    </button>

    <div class="wide" [ngClass]="{ 'scrollable-overflow': shouldUseScrollableOverflow }" *ngIf="isSavedFiltersMenuShowing" (click)="$event.stopPropagation()">
      <div class="saved-filter" *ngIf="filterViews.length">
        <div>
          <label class="white inline-block cursor-pointer" for="saved">Select Saved Filter:</label>
          <ng-select class="block focus-light-md"
                     id="saved"
                     (change)="setSelectedFilterView($event)"
                     [(ngModel)]="selectedFilterView.filterViewKey"
                     [multiple]="false"
                     [ngModelOptions]="{ standalone: true }"
                     placeholder="---No default saved filter selected---">
            <ng-option [value]="-1">---No default saved filter selected---</ng-option>
            <ng-option *ngFor="let filterView of filterViews" [value]="filterView.filterViewKey">
              {{ filterView.filterViewName }}
            </ng-option>
          </ng-select>
        </div>

        <ng-container *ngIf="selectedFilterView?.filterViewKey != null">
          <div class="filter-container two-column-grid">
            <div>
              <label class="white cursor-pointer" for="savedFilterName">Saved Filter Name</label>
              <input type="text"
                     id="savedFilterName"
                     class="block focus-light-md"
                     [formControlName]="FILTER_VIEW_NAME_FORM_CONTROL_NAME" />

              <div *ngIf="savedFiltersForm.get(FILTER_VIEW_NAME_FORM_CONTROL_NAME)?.hasError('required')
           && savedFiltersForm.get(FILTER_VIEW_NAME_FORM_CONTROL_NAME)?.touched"
                   class="error">
                Saved Filter Name is required
              </div>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedFlagType">Flag Type</label>
              <ng-select id="savedFlagType" class="block focus-light-md m-t--25" [formControlName]="FLAG_TYPE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let flag of filterLookups.flags" [value]="flag.id">
                  <span class="display-name">{{ flag.name }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedOffice">Project Office</label>
              <ng-select id="savedOffice" class="block focus-light-md" [formControlName]="OFFICE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let office of filterLookups.offices" [value]="office.id">
                  <span class="display-name">{{ office.name }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedDepartment">Project Department</label>
              <ng-select id="savedDepartment" class="block focus-light-md" [formControlName]="DEPARTMENT_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let department of filterLookups.departments" [value]="department.id">
                  <span class="display-name">{{ department.name }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedOwner">Owner Client Type</label>
              <ng-select id="savedOwner" class="block focus-light-md" [formControlName]="OWNER_CLIENT_TYPE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let ownerClientType of filterLookups.ownerClientTypes" [value]="ownerClientType.id">
                  <span class="display-name">{{ ownerClientType.name }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedPm1Office">PM 1 Office</label>
              <ng-select id="savedPm1Office" class="block focus-light-md" [formControlName]="PM1_OFFICE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let office of filterLookups.projectManager1Offices" [value]="office.officeCode">
                  <span class="display-name">{{ office.name }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedPm1Department">PM 1 Department</label>
              <ng-select id="savedPm1Department" class="block focus-light-md" [formControlName]="PM1_DEPARTMENT_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let department of filterLookups.projectManager1Departments" [value]="department.departmentCode">
                  <span class="display-name">{{ department.name }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedPm1Employee">PM 1</label>
              <ng-select id="savedPm1Employee" class="block focus-light-md" [formControlName]="PM1_EMPLOYEE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let employee of filterLookups.projectManager1Employees" [value]="employee.employeeNumber">
                  <span class="display-name">{{ employee.displayName }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedPm2Employee">PM 2</label>
              <ng-select id="savedPm2Employee" class="block focus-light-md" [formControlName]="PM2_EMPLOYEE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let employee of filterLookups.projectManager2Employees" [value]="employee.employeeNumber">
                  <span class="display-name">{{ employee.displayName }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedTaskManagerEmployee">Task Manager</label>
              <ng-select id="savedTaskManagerEmployee" class="block focus-light-md" [formControlName]="TASK_MANAGER_EMPLOYEE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let employee of filterLookups.taskManagerEmployees" [value]="employee.employeeNumber">
                  <span class="display-name">{{ employee.displayName }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white inline-block cursor-pointer" for="savedProjectAccountantEmployee">Project Accountant</label>
              <ng-select id="savedProjectAccountantEmployee" class="block focus-light-md" [formControlName]="PROJECT_ACCOUNTANT_EMPLOYEE_FORM_CONTROL_NAME" [multiple]="true" [closeOnSelect]="false">
                <ng-option *ngFor="let employee of filterLookups.projectAccountantEmployees" [value]="employee.employeeNumber">
                  <span class="display-name">{{ employee.displayName }}</span>
                </ng-option>
              </ng-select>
            </div>

            <div>
              <label class="white m-r--50">Status:</label>
              <label class="white cursor-pointer m-r--50" for="savedActiveStatus">
                <input class="focus-light-md" id="savedActiveStatus" type="checkbox" [formControlName]="ACTIVE_STATUS_FORM_CONTROL_NAME" />
                Active Projects
              </label>
              <label class="white cursor-pointer" for="savedCompletedStatus">
                <input class="focus-light-md" id="savedCompletedStatus" type="checkbox" [formControlName]="COMPLETED_STATUS_FORM_CONTROL_NAME" />
                Completed Projects
              </label>
            </div>

            <div>
              <label class="white cursor-pointer" for="savedDesignBuild">
                <input class="slide-toggle focus-light-md" id="savedDesignBuild" type="checkbox" [formControlName]="DESIGN_BUILD_FORM_CONTROL_NAME" />
                Design Build Projects
              </label>
            </div>

            <div>
              <label class="white cursor-pointer" for="defaultFilter">
                <input class="slide-toggle focus-light-md" id="defaultFilter" type="checkbox" [formControlName]="DEFAULT_FILTER_FORM_CONTROL_NAME" />
                Default Filter
              </label>
            </div>

            <div class="saved-filter-button-container" style="grid-column: 1 / -1;">
              <button class="secondary focus-light-md" (click)="saveApplyFilterView()" [disabled]="isFilterViewSaveInProgress">
                Save/Apply Filter
              </button>

              <button class="secondary focus-light-md" [disabled]="isFilterViewSaveInProgress" (click)="deleteConfirm.showModal()">
                Delete Filter
              </button>
            </div>
          </div>

          <dialog #deleteConfirm>
            <p>Are you sure you would like to delete the saved view?</p>
            <div class="btn-container txt-center">
              <button class="secondary" (click)="deleteFilter()">Ok</button>
              <button class="gray" (click)="deleteConfirm.close()">Cancel</button>
            </div>
          </dialog>
        </ng-container>
      </div>

      <div *ngIf="!filterViews.length">
        <p class="white">You have no saved filters</p>
      </div>
    </div>
  </div>
</form>
